import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, combineLatest, map, skip } from 'rxjs';
import { Indicator, Proof } from '../interfaces/models/indicator.model';
import { filterActive } from '../utils/filter-active';
@Injectable({
  providedIn: 'root'
})
export class IndicatorsService {

  constructor(private http: HttpClient) { }
  private domain = environment.domain;
  private ListIndicatorSub = new BehaviorSubject<any[] | null>(null);
  ListIndicators$ = this.ListIndicatorSub.asObservable().pipe(skip(1))

  private selectedpillarSub = new BehaviorSubject<null | number>(0);
  selectedPillar$ = this.selectedpillarSub.asObservable()

  private indicatorsSearchTerm = new BehaviorSubject<string>('');
  indicatorsSearchTerm$ = this.indicatorsSearchTerm.asObservable();
  selectedPillarIndicators$ = combineLatest([this.selectedPillar$, this.ListIndicators$]).pipe(map(([selectedId, ListIndicators]) => {
    const active = filterActive(ListIndicators);
    if (selectedId == 0) {
      return active;
    } else {
      return active.filter(x => x.pillar_id == selectedId);
    }
  }))
  filterdIndicators$ = combineLatest([this.selectedPillarIndicators$, this.indicatorsSearchTerm$]).pipe(map(([selectedPillarIndicators, indicatorsSearchTerm]) => {
    if (indicatorsSearchTerm == '') {
      return selectedPillarIndicators
    }
    else {
      return selectedPillarIndicators?.filter((obj: any) => obj.name.toLowerCase().includes(indicatorsSearchTerm?.toLowerCase()) || obj.in_charge_name.toLowerCase().includes(indicatorsSearchTerm?.toLowerCase()));
    }
  }))



  setSelectedPillarIdfn(id: number) {
    this.selectedpillarSub.next(id);
  }
  setListIndicators(strategyId: number) {
    this.http.get(this.domain + `strategies/${strategyId}/indicators`).pipe(map((data: any) => {
      return filterActive(data["data"]["indicators"]);
    })).subscribe(indicators => {
      this.ListIndicatorSub.next(indicators);
    });
  }

  getListIndicators(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators`).pipe(map((response: any) => {
      return filterActive(response['data']['indicators'] as Indicator[]);
    }));
  }
  getIndicator(strategyId: number, indicatorId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/${indicatorId}`);
  }
  setIndicateorSearchTermfn(term: string) {
    this.indicatorsSearchTerm.next(term);
  }
  createIndicator(model: Indicator, strategyId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/indicators`, model);
  }
  updateIndicator(model: Indicator, strategyId: number, indicatorId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/indicators/${indicatorId}`, model);
  }
  deleteIndicator(strategyId: number, indicatorId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/indicators/${indicatorId}`);
  }

  indicatorRelation(strategyId: number, indicatorId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/relations`).pipe(
      map((response: any) => this.filterRelationPayload(response))
    );
  }

  newIndicatorRelation(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/relations`).pipe(
      map((response: any) => this.filterRelationPayload(response))
    );
  }

  private filterRelationPayload(response: any) {
    const data = response?.['data'];
    if (data) {
      data.pillars = filterActive(data.pillars);
      data.goals = filterActive(data.goals);
      data.employees = filterActive(data.employees);
      data.indicators = filterActive(data.indicators);
    }
    return response;
  }


  updateTargetOutcome(strategyId: number, indicatorId: number, outcomeId: number, outComeModel: { target: number }) {
    return this.http.put(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/target`, outComeModel)

  }
  //actual
  updateOutcomeActual(strategyId: number, indicatorId: number, outcomeId: number, outComeModel: FormData) {
    return this.http.put(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/actual`, outComeModel)
  }
  ListOutcomeProofs(strategyId: number, indicatorId: number, outcomeId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/proofs`).pipe(map((response: any) => {
      return response['data']['proofs'] as Proof[];
    }))
  }
  downloadOutcomeProof(strategyId: number, indicatorId: number, outcomeId: number, proofId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/proofs/${proofId}`,
      {
        responseType: 'blob'
      });
  }
  deleteProof(strategyId: number, indicatorId: number, outcomeId: number, proofId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/proofs/${proofId}`);
  }





  getIndicatorsFileAuditor(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/indicators`);
  }

  getIndicatorOutcomesFileAuditor(strategyId: number, indicatorId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/indicators/${indicatorId}/outcomes`);
  }


  reviewAuditIndicatorFile(strategyId: number, auditFile: any) {
    return this.http.put(this.domain + `strategies/${strategyId}/auditor/${auditFile.id}`, auditFile);

  }


  reviewAuditFile(strategyId: number, auditFile: any) {
    return this.http.put(this.domain + `strategies/${strategyId}/auditor/${auditFile.id}`, auditFile);
  }

  listSingleOutcomesFiles(strategyId: number, indicatorId: number, auditFile: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/auditor/indicators/${indicatorId}/outcomes/${auditFile}`);
  }
  getOutcomeStatus(strategyId: number, indicatorId: number, outcomeId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/indicators/${indicatorId}/outcomes/${outcomeId}/status`);
  }
  ListGoalsIndicators(strategyId: number, goalId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/goals/${goalId}/indicators`);
  }

}
